/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { CALL_API } from '../middleware';
import {
  accessType,
  addFundType,
  addPlanType,
  ADD_FUND,
  ADD_FUND_SUCCESS,
  ADD_PLAN,
  ADD_PLAN_SUCCESS,
  ClassPlanProps,
  FundProps,
  GetFundsListResponseBody,
  GET_FUNDS,
  GET_FUNDS_ACCESS,
  GET_FUNDS_ACCESS_SUCCESS,
  GET_FUNDS_LIST,
  GET_FUNDS_LIST_SUCCESS,
  EXPORT_FUNDS,
  EXPORT_FUNDS_SUCCESS,
  GET_FUNDS_SUCCESS,
  GET_PLAN_DETAILS,
  GET_PLAN_DETAILS_SUCCESS,
  GET_PLAN_SUCCESS,
  UPDATE_FUND,
  UPDATE_FUND_SUCCESS,
  UPDATE_PLAN,
  UPDATE_PLAN_SUCCESS,
  GET_DIRECTAPPLICABLEFUNDS_SUCCESS,
  GET_DIRECTAPPLICABLEFUNDS,
  GET_FREEZE_ACCESS_SUCCESS,
  GET_FREEZE_ACCESS,
  freezeAccessType,
  UPDATE_FREEZE_SUCCESS,
  UPDATE_FREEZE,
  distType,
  GET_DIST_SUCCESS,
  GET_DIST,
  FundDraft,
  SaveFundDraftStepBody,
  SubmitFundDraftResponse,
  GET_FUND_DRAFTS,
  GET_FUND_DRAFTS_SUCCESS,
  GET_FUND_DRAFT,
  GET_FUND_DRAFT_SUCCESS,
  SAVE_FUND_DRAFT_STEP,
  SAVE_FUND_DRAFT_STEP_SUCCESS,
  SUBMIT_FUND_DRAFT,
  SUBMIT_FUND_DRAFT_SUCCESS,
} from '../types/funds';

export type fundsParams = {
  isActive?: boolean;
  trusteeId?: number;
  fundManagerId?: number;
  freezeStatus?: boolean;
};

export const getFundsList =
  (params?: fundsParams) =>
  async (dispatch: any): Promise<GetFundsListResponseBody> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/funds/list`,
        method: 'GET',
        types: [GET_FUNDS_LIST_SUCCESS, GET_FUNDS_LIST],
        params,
      },
    });
  };

export const exportFunds =
  () =>
  async (dispatch: any): Promise<Blob> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/funds/export-funds`,
        method: 'GET',
        types: [EXPORT_FUNDS_SUCCESS, EXPORT_FUNDS],
        contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
    });
  };

export const addFund =
  (body: addFundType) =>
  async (dispatch: any): Promise<FundProps[]> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/funds/addScheme`,
        method: 'POST',
        types: [ADD_FUND_SUCCESS, ADD_FUND],
        body,
      },
    });
  };

export const addPlan =
  (body: addPlanType) =>
  async (dispatch: any): Promise<ClassPlanProps[]> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/funds/addPlan`,
        method: 'POST',
        types: [ADD_PLAN_SUCCESS, ADD_PLAN],
        body,
      },
    });
  };

export const updateFund =
  (Id: number, body: any) =>
  async (dispatch: any): Promise<FundProps[]> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/funds/updateScheme/${Id}`,
        method: 'POST',
        types: [UPDATE_FUND_SUCCESS, UPDATE_FUND],
        body,
      },
    });
  };

export const updatePlan =
  (Id: number, body: any) =>
  async (dispatch: any): Promise<ClassPlanProps[]> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/funds/updatePlan/${Id}`,
        method: 'POST',
        types: [UPDATE_PLAN_SUCCESS, UPDATE_PLAN],
        body,
      },
    });
  };

export const fundAccess =
  () =>
  async (dispatch: any): Promise<accessType> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/funds/fundSetupAccess`,
        method: 'GET',
        types: [GET_FUNDS_ACCESS_SUCCESS, GET_FUNDS_ACCESS],
      },
    });
  };

export const freezeAccess =
  () =>
  async (dispatch: any): Promise<freezeAccessType> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/schemeFreezeAccess`,
        method: 'GET',
        types: [GET_FREEZE_ACCESS_SUCCESS, GET_FREEZE_ACCESS],
      },
    });
  };

export const updateFreezeStatus =
  (Id: number, body: any) =>
  async (dispatch: any): Promise<FundProps[]> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/funds/updateFreezeStatus/${Id}`,
        method: 'POST',
        types: [UPDATE_FREEZE_SUCCESS, UPDATE_FREEZE],
        body,
      },
    });
  };

export const getPlanList =
  (Id: string) =>
  async (dispatch: any): Promise<GetFundsListResponseBody> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/funds/schemes/${Id}`,
        method: 'GET',
        types: [GET_PLAN_SUCCESS, GET_PLAN_SUCCESS],
      },
    });
  };

export const getPlanDetail =
  (Id: string) =>
  async (dispatch: any): Promise<ClassPlanProps[]> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/funds/plans/${Id}`,
        method: 'GET',
        types: [GET_PLAN_DETAILS_SUCCESS, GET_PLAN_DETAILS],
      },
    });
  };

export const getFunds =
  (params?: fundsParams) =>
  async (dispatch: any): Promise<GetFundsListResponseBody> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/funds`,
        method: 'GET',
        types: [GET_FUNDS_SUCCESS, GET_FUNDS],
        params,
      },
    });
  };

export const getDirectApplicableFunds =
  (params: { isActive?: boolean }) =>
  async (dispatch: any): Promise<FundProps[]> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/funds/direct-applicable-plans`,
        method: 'GET',
        types: [GET_DIRECTAPPLICABLEFUNDS_SUCCESS, GET_DIRECTAPPLICABLEFUNDS],
        params,
      },
    });
  };

export const getDist =
  () =>
  async (dispatch: any): Promise<distType> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/get-distributor`,
        method: 'GET',
        types: [GET_DIST, GET_DIST_SUCCESS],
      },
    });
  };

export const getFundDrafts =
  (params?: { status?: string }) =>
  async (dispatch: any): Promise<FundDraft[] | { drafts: FundDraft[] }> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/funds/drafts`,
        method: 'GET',
        types: [GET_FUND_DRAFTS_SUCCESS, GET_FUND_DRAFTS],
        params,
      },
    });
  };

export const getFundDraft =
  (id: string) =>
  async (dispatch: any): Promise<FundDraft> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/funds/draft/${id}`,
        method: 'GET',
        types: [GET_FUND_DRAFT_SUCCESS, GET_FUND_DRAFT],
      },
    });
  };

export const saveFundDraftStep =
  (body: SaveFundDraftStepBody, options?: { showToast?: boolean }) =>
  async (dispatch: any): Promise<FundDraft> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/funds/draft/save-step`,
        method: 'POST',
        types: [SAVE_FUND_DRAFT_STEP_SUCCESS, SAVE_FUND_DRAFT_STEP],
        body,
        showToast: options?.showToast ?? false,
        toastMessage: 'Draft saved',
      },
    });
  };

export const submitFundDraft =
  (id: string) =>
  async (dispatch: any): Promise<SubmitFundDraftResponse> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/funds/draft/${id}/submit`,
        method: 'POST',
        types: [SUBMIT_FUND_DRAFT_SUCCESS, SUBMIT_FUND_DRAFT],
        showToast: true,
        toastMessage: 'Fund created successfully',
      },
    });
  };
